<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <el-row :gutter="20">
      <!-- 基本信息卡片 -->
      <el-col :span="12">
        <div class="page-card">
          <div class="page-card__header">
            <span style="font-weight: bold">基本信息</span>
          </div>

          <div class="page-card__body" style="font-size: 14px">
            <el-form
              :model="baseform"
              :rules="rules"
              ref="baseform"
              label-width="100px"
            >
              <el-row style="text-align: left" :gutter="16">
                <el-col :span="5"> 公司LOGO：</el-col>
                <el-col :span="4">
                  <el-image :src="img"></el-image>
                </el-col>
                <el-col :span="15">
                  <el-upload
                    class="avatar-uploader"
                    :action="imagesrc"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :headers="headers"
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-button size="small" type="primary" round
                    >点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      最佳展示尺寸：1:1，建议500 x 500像素
                    </div>
                  </el-upload>
                </el-col>
              </el-row>

              <el-form-item label="用户名：" style="margin-top: 20px">
                <el-input
                  :disabled="disabledType"
                  v-model="baseform.username"
                ></el-input>
              </el-form-item>

              <el-form-item label="展位号：" style="margin-top: 20px">
                <el-input
                  :disabled="disabledType"
                  v-model="baseform.booth"
                ></el-input>
              </el-form-item>

              <el-form-item
                prop="name"
                label="公司名称："
                style="margin-top: 20px"
              >
                <el-input
                  placeholder="填入公司名称"
                  v-model="baseform.name"
                ></el-input>
              </el-form-item>

              <el-form-item label="公司分类：">
                <el-checkbox-group v-model="type" style="text-align: left">
                  <el-checkbox label="紧固件"></el-checkbox>
                  <el-checkbox label="设备"></el-checkbox>
                  <el-checkbox label="模具"></el-checkbox>
                  <el-checkbox label="表面处理"></el-checkbox>
                  <el-checkbox label="原材料"></el-checkbox>
                  <el-checkbox label="检测"></el-checkbox>
                  <el-checkbox label="媒体"></el-checkbox>
                  <el-checkbox label="协会"></el-checkbox>
                  <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item prop="info" label="  公司简介：">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="baseform.info"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="product" label="主营产品：">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="baseform.product"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>

              <el-row style="margin-top: 30px">
                <el-button
                  round
                  size="small"
                  @click="onBaseSubmit('baseform')"
                  type="primary"
                >
                  确定保存
                </el-button>
                <el-button round size="small" @click="baseUpdate('baseform')"
                >重置
                </el-button>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-col>

      <el-col :span="12">
        <!-- 联系信息卡片 -->
        <div class="page-card">
          <div class="page-card__header">
            <span style="font-weight: bold">联系信息</span>
          </div>

          <div class="page-card__body" style="text-align: left; font-size: 14px">
            <el-form
              :model="contactsForm"
              :rules="rules"
              ref="contactsForm"
              label-width="100px"
            >
              <el-form-item prop="linkman" label="联系人：">
                <el-input
                  placeholder="填入公司联系人"
                  v-model="contactsForm.linkman"
                ></el-input>
              </el-form-item>
              <el-row style="margin-top: 20px" :gutter="10">
                <el-col :span="12">
                  <el-form-item prop="mobile" label="手机：">
                    <el-input
                      maxlength="11"
                      placeholder="填入公司手机"
                      v-model="contactsForm.mobile"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="is_show_phone" label="公开手机号：">
                    <el-radio-group v-model="contactsForm.is_show_phone">
                      <el-radio :label="false">否</el-radio>
                      <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row style="margin-top: 20px" :gutter="10">
                <el-col :span="12">
                  <el-form-item prop="tel" label="电话：">
                    <el-input
                      placeholder="填入公司电话"
                      v-model="contactsForm.tel"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="email" label="邮箱：">
                    <el-input
                      placeholder="填入公司邮箱"
                      v-model="contactsForm.email"
                    ></el-input>
                  </el-form-item>
                </el-col>

              </el-row>

              <el-form-item label="网址：">
                <el-input
                  placeholder="填入公司网址"
                  v-model="contactsForm.website"
                ></el-input>
              </el-form-item>

              <el-form-item label="地址：" prop="address">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="填入地址"
                  v-model="contactsForm.address"
                ></el-input>
              </el-form-item>

              <el-row style="text-align: left" :gutter="16">
                <el-form-item label="微信二维码：">
                  <el-col :span="8" v-if="contactsForm.wechat_qrcode">
                    <el-image :src="wx_chat_img"></el-image>
                  </el-col>
                  <el-col :span="8">
                    <el-upload
                      class="avatar-uploader"
                      :action="wxChatSrc"
                      :show-file-list="false"
                      :on-success="wxChatSuccess"
                      :headers="headers"
                      :before-upload="beforeAvatarUpload"
                    >
                      <el-button size="small" type="primary" round
                      >点击上传
                      </el-button>
                    </el-upload>
                  </el-col>
                </el-form-item>
              </el-row>

              <el-row style="margin-top: 30px; text-align: center">
                <el-button
                  round
                  size="small"
                  @click="contactsSubmit('contactsForm')"
                  type="primary"
                >
                  确定保存
                </el-button>
                <el-button
                  round
                  size="small"
                  @click="contactUpdate('contactsForm')"
                >重置
                </el-button>
              </el-row>
            </el-form>
          </div>
        </div>

        <!-- 展示视频卡片 -->
        <div class="page-card" style="margin-top: 16px">
          <div class="page-card__header">
            <span style="font-weight: bold">展示视频</span>
          </div>
          <div class="page-card__body" style="text-align: left">
            <el-radio-group v-model="infoData.video_type">
              <el-radio :label="1">上传视频源</el-radio>
              <el-radio :label="2">上传腾讯视频链接</el-radio>
            </el-radio-group>
            <span
              style="
                color: #ff6000;
                font-weight: bold;
                font-size: 12px;
                line-height: 20px;
                margin-left: 30px;
              "
            >* 两个视频选项只能选择其中一个</span
            >
          </div>

          <div class="page-card__body" v-if="infoData.video_type === 1">
            <el-row style="text-align: left" :gutter="16" v-loading="loading">
              <el-col :span="12">
                <div :span="12" v-if="infoData.video !== ''">
                  <video
                    width="100%"
                    height="140"
                    :controls="controls"
                    :src="video"
                    :poster="videoImg"
                  ></video>
                </div>
                <div :span="12" v-else>
                  <el-image
                    src="/static/img/imgbg.png"
                    style="width: 270px; height: 140px"
                  ></el-image>
                </div>
                <div :span="4">
                  <el-upload
                    class="avatar-uploader"
                    :action="videoSrc"
                    :show-file-list="false"
                    :on-success="VideoSuccess"
                    :headers="headers"
                    :on-progress="progress"
                    :before-upload="beforeVideoUpload"
                    :on-error="videoError"
                  >
                    <el-button size="small" type="primary" round
                    >上传视频
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      * 格式为.mp4的文件，大小不超过50MB
                    </div>
                  </el-upload>
                </div>
              </el-col>
              <el-col :span="12">
                <div :span="14">
                  <el-image
                    v-if="infoData.video_img === ''"
                    src="/static/img/imgbg.png"
                    style="width: 270px; height: 140px"
                  ></el-image>
                  <el-image
                    v-else
                    :src="videoImg"
                    fit="scale-down"
                    style="
                      width: 270px;
                      height: 140px;
                      border: 1px solid #999999;
                    "
                  ></el-image>
                </div>
                <div :span="8">
                  <el-upload
                    class="avatar-uploader"
                    :action="videoImagesrc"
                    :show-file-list="false"
                    :on-success="handleVideoSuccess"
                    :headers="headers"
                    :before-upload="beforeAvatarUploads"
                  >
                    <el-button size="small" type="primary" round
                    >上传封面
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      * 建议封面尺寸：1080px X 720px
                    </div>
                  </el-upload>
                </div>
              </el-col>
            </el-row>

            <div style="padding: 20px 0">
              <el-button
                @click="videoBoth"
                type="primary"
                size="small"
                style="width: 100px"
              >保存
              </el-button>
              <br/>
              <span style="font-size: 12px; color: #ff6000; font-weight: bold"
              >* 点击保存后视频和封面才会生效</span
              >
            </div>
          </div>
          <div
            class="page-card__body"
            style="height: 360px"
            v-else-if="infoData.video_type === 2"
          >
            <div style="text-align: left; padding: 10px 0; font-size: 14px">
              输入腾讯视频链接：
            </div>
            <el-input v-model="infoData.video_tx"></el-input>
            <p style="text-align: left; font-size: 12px">
              * 例子：https://v.qq.com/x/page/f3309ndjx8b.html
            </p>
            <div style="padding: 20px 0">
              <el-button
                @click="sumbitVideoTx"
                type="primary"
                size="small"
                style="width: 100px"
              >保存
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    name: "infoList",
    data() {
      let iphoneNumber = (rule, value, callback) => {
        let reg = /1[0-9]{10}$/;
        setTimeout(() => {
          if (!value) {
            return callback(new Error("号码不能为空"));
          } else {
            if (!reg.test(value)) {
              callback(new Error("检查你的号码"));
            } else {
              callback();
            }
          }
        }, 500);
      };

      let emailNumber = (rule, value, callback) => {
        let reg =
          /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
        setTimeout(() => {
          if (!value) {
            return callback(new Error("邮箱不能为空"));
          } else {
            if (!reg.test(value)) {
              callback(new Error("检查你的邮箱格式"));
            } else {
              callback();
            }
          }
        }, 500);
      };
      return {
        baseInfoShow: true,
        contactInfoShow: true,
        videoShow: true,
        infoData: [],
        type: [],
        img: "",
        wx_chat_img: "",
        controls: true,

        headers: {Authorization: "JWT " + localStorage.getItem("token")},
        imagesrc: this.baseUrl + "/user/uploadfile/logo/",
        wxChatSrc: this.baseUrl + "/user/uploadfile/wxchat/",
        videoImagesrc: this.baseUrl + "/user/uploadfile/video_img/",
        videoSrc: this.baseUrl + "/user/uploadfile/video/",
        imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
        wx_chat_Url:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/wxchat/",
        videoUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/video/",
        video_imgUrl:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/video_img/",
        loading: false,

        videoImg: "",
        video: "",
        video_tx: "",
        disabledType: true,
        videoLink: "",

        baseform: {
          logo: "",
          name: "",
          type: [],
          info: "",
          product: "",
        },
        contactsForm: {
          linkman: "",
          mobile: "",
          tel: "",
          website: "",
          address: "",
          email: "",
          wechat_qrcode: "",
        },

        rules: {
          name: [{required: true, message: "请输入公司名", trigger: "blur"}],
          info: [{required: true, message: "请输入简介", trigger: "blur"}],
          product: [{required: true, message: "请输入产品", trigger: "blur"}],
          address: [{required: true, message: "请输入地址", trigger: "blur"}],
          linkman: [{required: true, message: "请输入联系人", trigger: "blur"}],
          mobile: [{required: true, validator: iphoneNumber, trigger: "blur"}],
          tel: [{required: true, message: "请输入电话号码", trigger: "blur"}],
          email: [{required: true, validator: emailNumber, trigger: "blur"}],
        },
      };
    },
    mounted() {
      this.getinfo();
    },

    methods: {
      /** 获取用户信息 */
      getinfo() {
        let id = localStorage.getItem("userid");
        let url = this.baseUrl + "/user/users/" + id + "/";
        api.fetchData(url).then((res) => {
          this.infoData = res;
          if (this.infoData.video_type !== 1 && this.infoData.video_type !== 2) {
            this.infoData.video_type = 1;
          }
          this.img = this.imgUrl + this.infoData.logo;
          this.wx_chat_img = this.wx_chat_Url + this.infoData.wechat_qrcode;
          this.videoImg = this.video_imgUrl + this.infoData.video_img;
          this.video = this.videoUrl + this.infoData.video;
          this.baseform = res;
          this.type = res.type;
          if (this.type !== "" && this.type !== null) {
            this.type = this.type.split(",");
          } else {
            this.type = [];
          }

          this.contactsForm = res;
        });
      },

      /** 提交基本信息 */
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = localStorage.getItem("userid");
            let url = this.baseUrl + "/user/users/" + id + "/";
            this.baseform.type = this.type.toString();
            api
              .patchData(url, {
                logo: this.baseform.logo,
                name: this.baseform.name,
                type: this.baseform.type,
                info: this.baseform.info,
                product: this.baseform.product,
              })
              .then((res) => {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getinfo();
              });
          }
        });
      },
      /** 提交联系信息 */
      contactsSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = localStorage.getItem("userid");
            let url = this.baseUrl + "/user/users/" + id + "/";

            api
              .patchData(url, {
                linkman: this.contactsForm.linkman,
                mobile: this.contactsForm.mobile,
                tel: this.contactsForm.tel,
                website: this.contactsForm.website,
                address: this.contactsForm.address,
                email: this.contactsForm.email,
                wechat_qrcode: this.contactsForm.wechat_qrcode,
                 is_show_phone:this.contactsForm.is_show_phone,
              })
              .then((res) => {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getinfo();
              });
          }
        });
      },
      /** 提交腾讯视频链接 */
      sumbitVideoTx() {
        let id = localStorage.getItem("userid");
        let url = this.baseUrl + "/user/users/" + id + "/";
        let video_type = 2;
        let video_tx = this.infoData.video_tx;
        api
          .patchData(url, {
            video_tx: video_tx,
            video_type: video_type,
          })
          .then((res) => {
            this.getinfo();
            this.$message({
              message: "上传成功",
              type: "success",
            });
          });
      },

      /** 公司LOGO上传成功回调 */
      handleAvatarSuccess(res, file) {
        this.baseform.logo = res.filename;
        this.img = this.imgUrl + this.baseform.logo;
      },
      /** 微信二维码上传成功回调 */
      wxChatSuccess(res, file) {
        this.contactsForm.wechat_qrcode = res.filename;
        this.wx_chat_img = this.wx_chat_Url + this.contactsForm.wechat_qrcode;
      },
      /** 视频上传成功回调 */
      VideoSuccess(res, file) {
        this.video = this.videoUrl + res.filename;
        this.infoData.video = res.filename;
        this.loading = false;
      },

      /** 保存视频和封面 */
      videoBoth() {
        let id = localStorage.getItem("userid");
        let video_type = 1;
        let url = this.baseUrl + "/user/users/" + id + "/";

        api
          .patchData(url, {
            video_img: this.infoData.video_img,
            video: this.infoData.video,
            video_type: video_type,
          })
          .then((res) => {
            this.getinfo();
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.loading = false;
          });
      },

      /** 视频上传失败回调 */
      videoError(res, file) {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
        this.loading = false;
      },
      /** 视频封面上传成功回调 */
      handleVideoSuccess(res, file) {
        this.videoImg = this.video_imgUrl + res.filename;
        this.infoData.video_img = res.filename;
      },

      /** 视频上传前校验 */
      beforeVideoUpload(file) {
        const isVideo = file.type === "video/mp4";
        const isVideo50M = file.size / 1024 / 1024 < 50;
        if (!isVideo) {
          this.$message.error("上传视频只能是 MP4 格式!");
        }
        if (!isVideo50M) {
          this.$message.error("上传视频大小不能大于50M!");
        }
        return isVideo && isVideo50M;
      },

      /** 图片上传前校验 */
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("上传封面图片只能是 JPG、PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传封面图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },

      /** 封面图片上传前校验（空实现） */
      beforeAvatarUploads() {
      },

      /** 视频上传进度处理 */
      progress() {
        this.loading = true;
      },

      /** 重置基本信息表单 */
      baseUpdate(formName) {
        this.$refs[formName].resetFields();
        this.getinfo();
      },

      /** 重置联系信息表单 */
      contactUpdate(formName) {
        this.$refs[formName].resetFields();
        this.getinfo();
      },

      /** 切换视频展示状态 */
      uploadVideo() {
        this.videoShow = this.videoShow === true ? false : true;
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage/infoList.vue